import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { MaterialModule } from './libreriasUI/material/material.module';


// COM Componentes ****************
import { CardMonitoreoDetalleSucursalesComponent }
  from './custom-components/card-monitoreo-detalle-sucursales/card-monitoreo-detalle-sucursales.component';
import { TituloInformativoComponent } from './layoutComponents/titulo-informativo/titulo-informativo.component';
import { ModalGeneralComponent } from './layoutComponents/modal-general/modal-general.component';
import { NavBarComponent } from './layoutComponents/nav-bar/nav-bar.component';
import { SideBarComponent } from './layoutComponents/side-bar/side-bar.component';
import { NotFoundComponent } from './layoutComponents/not-found/not-found.component';
import { NavBarLandingComponent } from './layoutComponents/nav-bar-landing/nav-bar-landing.component';
import { TablaOtrosProductosComponent } from './layoutComponents/tabla-otros-productos/tabla-otros-productos.component';
import { TablaBalanceOtrosProductosEmpresasComponent }
  from './layoutComponents/tabla-balance-otros-productos-empresas/tabla-balance-otros-productos-empresas.component';
import { BalanceOtrosProductosComponent } from './layoutComponents/balance-otros-productos/balance-otros-productos.component';
import { SafeUrlPipe } from '../core/pipes/safe-url.pipe';
import { CarouselComponent } from './layoutComponents/carousel/carousel.component';
import { FooterComponent } from './layoutComponents/footer/footer.component';


import { SwiperModule } from 'swiper/angular';
import { FocusDirective } from '../core/directivas/focus.directive';
import { FormsModule } from '@angular/forms';
import { CampoFechaComponent } from './custom-components/campo-fecha/campo-fecha.component';
import { FiltroBuscarComponent } from './custom-components/filtro-buscar/filtro-buscar.component';
import { VisualizadorPdfComponent } from './layoutComponents/visualizador-pdf/visualizador-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import {MatMenuModule} from '@angular/material/menu';
import { TituloInformativoOpcionesComponent } from './layoutComponents/titulo-informativo-opciones/titulo-informativo-opciones.component';



@NgModule({
  declarations: [
    NavBarComponent,
    CardMonitoreoDetalleSucursalesComponent,
    SideBarComponent,
    TituloInformativoComponent,
    ModalGeneralComponent,
    NotFoundComponent,
    NavBarLandingComponent,
    TablaOtrosProductosComponent,
    TablaBalanceOtrosProductosEmpresasComponent,
    BalanceOtrosProductosComponent,
    SafeUrlPipe,
    CarouselComponent,
    FooterComponent,
    FocusDirective,
    CampoFechaComponent,
    FiltroBuscarComponent,
    VisualizadorPdfComponent,
    TituloInformativoOpcionesComponent,
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MaterialModule,
    SwiperModule,
    FormsModule,
    PdfViewerModule,
    MatMenuModule
  ],
  exports: [
    NavBarComponent,
    CardMonitoreoDetalleSucursalesComponent,
    SideBarComponent,
    TituloInformativoComponent,
    ModalGeneralComponent,
    NotFoundComponent,
    NavBarLandingComponent,
    BalanceOtrosProductosComponent,
    SafeUrlPipe,
    CarouselComponent,
    FooterComponent,
    FocusDirective,
    CampoFechaComponent,
    FiltroBuscarComponent,
    VisualizadorPdfComponent,
    TituloInformativoOpcionesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
